'use client';

import { Fragment } from 'react';
import { TextLink } from '@petsmart-ui/sparky';

import { DEVICE_TYPE, useDeviceType } from '@libs/common-next';
import { dataLayerPush, layoutEvents, getBaseUrlJoined } from '@libs/analytics';
import { ComponentResolver } from '../../utils/ComponentResolver';
import { LegacyUsableNet } from '../LegacyUsableNet';
import type { LegacyNavAdoptionsProps } from './types';

import './LegacyNavAdoptions.scss';
import { propsMapper, getLinkFromLinkOrLinkAction } from '../../utils';
import type { Entry, LinkAction, Link } from '../../types';

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerClick });

const TREATS_SIGN_HEAD_TEXT = 'Sign up, earn points, get treats';

export default function LegacyNavAdoptions({ livesSaved, secondaryNavigation }: LegacyNavAdoptionsProps) {
    const { navigationLinks, tabletNavigationLinks } = secondaryNavigation?.fields ?? {};
    const deviceSize = useDeviceType();
    const links = propsMapper<LinkAction | Link>(
        (deviceSize === DEVICE_TYPE.DESKTOP ? (navigationLinks as Entry[]) : (tabletNavigationLinks as Entry[])) ?? []
    );

    const flatLinks = links.map(linkOrLinkAction => getLinkFromLinkOrLinkAction(linkOrLinkAction));

    return (
        <>
            <div className="legacy-topnav__container">
                <LegacyUsableNet />

                {flatLinks.map(({ actionText, sysId, webUrl }) => (
                    <Fragment key={sysId ?? webUrl ?? actionText}>
                        <div className="legacy-topnav__divider">|</div>
                        <TextLink
                            href={webUrl}
                            className="legacy-topnav__link"
                            onClick={() =>
                                dataLayerPush(
                                    trackingData({
                                        selection: actionText,
                                        link_url: getBaseUrlJoined(webUrl),
                                    })
                                )
                            }
                        >
                            {actionText}
                        </TextLink>
                    </Fragment>
                ))}
            </div>
            <div className="legacy-topnav__container legacy-topnav__container--center">
                <ComponentResolver entry={livesSaved as LegacyNavAdoptionsProps['livesSaved']} />
            </div>
            <div className="legacy-topnav__container">{TREATS_SIGN_HEAD_TEXT}</div>
        </>
    );
}
